// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2915":"apiWorker","4013":"sharedApiWorker"}[chunkId] || chunkId) + "." + {"759":"773a0f296ce2a796","2915":"88e665f3075ccddf","4013":"a747a2d3a26100bb","7298":"dd71051fe5dc4a17"}[chunkId] + ".js";
};